import React, { useState } from 'react';

const MONTHS = [
  'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
];
const EN_MONTHS = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December'
];

export default function PaymentCalendar({ paymentHistory = [], onChange, editable = false }) {
  // Собираем список годов из paymentHistory
  const years = paymentHistory.map(ph => ph.year).sort();
  const now = new Date();
  const currentYear = now.getFullYear();
  const allYears = [...years];
  // Добавляем возможность выбрать до 2027 года
  for (let y = currentYear; y <= 2027; y++) {
    if (!allYears.includes(y)) allYears.push(y);
  }
  allYears.sort();

  const [selectedYear, setSelectedYear] = useState(
    years.length ? years[years.length - 1] : currentYear
  );

  // Получить статус оплаты месяца
  const getMonthStatus = (year, monthIdx) => {
    const entry = paymentHistory.find(ph => ph.year === year);
    if (!entry) return false;
    return entry.months?.[EN_MONTHS[monthIdx]] || false;
  };

  // Обработка клика по статусу оплаты
  const handleToggle = (year, monthIdx) => {
    if (!editable) return;
    const newHistory = paymentHistory.map(ph => {
      if (ph.year !== year) return ph;
      return {
        ...ph,
        months: {
          ...ph.months,
          [EN_MONTHS[monthIdx]]: !ph.months[EN_MONTHS[monthIdx]]
        }
      };
    });
    onChange && onChange(newHistory);
  };

  // Добавить новый год
  const handleAddYear = (yearToAdd) => {
    if (years.includes(yearToAdd)) return;
    const newEntry = {
      year: yearToAdd,
      months: EN_MONTHS.reduce((acc, m) => ({ ...acc, [m]: false }), {})
    };
    onChange && onChange([...paymentHistory, newEntry]);
    setSelectedYear(yearToAdd);
  };

  const yearExists = years.includes(selectedYear);

  return (
    <div style={{ margin: '32px 0', maxWidth: 400 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
        <span style={{ fontWeight: 500 }}>Год:</span>
        <select value={selectedYear} onChange={e => setSelectedYear(Number(e.target.value))} style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #ccc' }}>
          {allYears.map(y => <option value={y} key={y}>{y}</option>)}
        </select>
        {editable && !yearExists && (
          <button onClick={() => handleAddYear(selectedYear)} style={{ marginLeft: 8, background: '#6c3be4', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 12px', fontWeight: 500, cursor: 'pointer' }}>Добавить год</button>
        )}
        {editable && yearExists && !years.includes(currentYear + 1) && selectedYear === currentYear + 1 && (
          <button onClick={() => handleAddYear(currentYear + 1)} style={{ marginLeft: 8, background: '#6c3be4', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 12px', fontWeight: 500, cursor: 'pointer' }}>Добавить {currentYear + 1}</button>
        )}
      </div>
      <table style={{ borderCollapse: 'collapse', width: '100%', background: '#fff', borderRadius: 10, boxShadow: '0 1px 8px #ece9f7', overflow: 'hidden' }}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left', padding: '8px 10px', fontWeight: 600, fontSize: 15, background: '#f7f7f9', borderBottom: '1px solid #ece9f7' }}>Месяц</th>
            <th style={{ textAlign: 'center', padding: '8px 10px', fontWeight: 600, fontSize: 15, background: '#f7f7f9', borderBottom: '1px solid #ece9f7' }}>Статус</th>
          </tr>
        </thead>
        <tbody>
          {MONTHS.map((m, i) => {
            const paid = getMonthStatus(selectedYear, i);
            return (
              <tr key={i}>
                <td style={{ padding: '10px 10px', fontWeight: 500 }}>{m}</td>
                <td style={{ textAlign: 'center', padding: '10px 0' }}>
                  <button
                    type="button"
                    onClick={() => handleToggle(selectedYear, i)}
                    disabled={!editable || !yearExists}
                    style={{
                      background: paid ? '#e6fbe6' : '#ffeaea',
                      color: paid ? '#1a7f1a' : '#d32f2f',
                      border: '1px solid #ece9f7',
                      borderRadius: 8,
                      fontWeight: 600,
                      fontSize: 15,
                      minWidth: 120,
                      padding: '7px 0',
                      cursor: editable && yearExists ? 'pointer' : 'not-allowed',
                      transition: 'background 0.2s',
                    }}
                  >
                    {paid ? 'Оплачено' : 'Не оплачено'}
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
} 